
import {
    Typography,
} from '@mui/material';
import { glb_sv} from 'src/utils';
import { t } from 'i18next';
import moment from 'moment';

export function renderContent(notification) {
    const title = (
        <>
            {notification?.type_noty === '1' ? (
                <Typography
                    variant="subtitle2"
                    paddingLeft={2}
                    width={'100%'}
                    sx={{ lineHeight: '20px', overflow: 'hidden' }}
                >
                    {glb_sv.convertMultipleLanguages(notification.device_nm)}
                    {notification.key_funct === 'er2' ? (
                        <Typography
                            sx={{ lineHeight: '20px', overflow: 'hidden', color: 'text.secondary' }}
                            component="span"
                            variant="body2"
                        >
                            {' '}
                            {t('remaining')} {moment(notification.expiry_date, 'YYYYMMDD').diff(moment(), 'days')}{' '}
                            {t('day')}
                        </Typography>
                    ) : notification.cabinet_type !== 'round' ? (
                        <Typography
                            sx={{ lineHeight: '20px', overflow: 'hidden', color: 'text.secondary' }}
                            component="span"
                            variant="body2"
                        >
                            &nbsp; {notification.cabinet_nm} - {notification.drawer_nm} -{' '}
                            {`${t('cell')} [ ${notification?.cell_row} : ${notification?.cell_column} ]`}
                        </Typography>
                    ) : (
                        <Typography
                            sx={{ lineHeight: '20px', overflow: 'hidden', color: 'text.secondary' }}
                            component="span"
                            variant="body2"
                        >
                            &nbsp; {notification.cabinet_nm} - {notification.drawer_nm} - {t('ordinal_number')}:{' '}
                            {`[${notification?.cell_column}]`}
                        </Typography>
                    )}
                </Typography>
            ) : (
                <>
                    <Typography variant="subtitle2" paddingLeft={2}>
                        {glb_sv.convertMultipleLanguages(notification.device_nm)}
                        <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                            &nbsp; {notification.key_mean} x{notification.qty}
                        </Typography>
                    </Typography>
                </>
            )}
        </>
    );
    return {
        avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
        title,
    };
}
